<div class="mui-wizard-stepper">
  <ul class="mui-wizard-stepper_list" *ngIf="wizard">
    <li
      *ngFor="let step of wizard.steps; let i = index"
      class="mui-wizard-stepper_step"
      role="tab"
      [tabindex]="linear ? -1 : 0"
      [attr.id]="wizard._getStepLabelId(i)"
      (click)="selectStep(step, $event)"
      (keydown.enter)="selectStep(step, $event)"
      (keydown.space)="selectStep(step, $event)"
      (keydown.arrowRight)="focusNextStep($event)"
      (keydown.arrowLeft)="focusPrevStep($event)"
      [class.active]="wizard.selected === step"
      [class.before-active]="wizard.selectedIndex === i + 1"
      [class.editable]="step.editable"
      [class.completed]="step.completed"
      [class.linear]="linear"
      [attr.aria-controls]="wizard._getStepContentId(i)"
      [attr.aria-posinset]="i"
      [attr.aria-setsize]="wizard.steps.length"
      [attr.aria-disabled]="linear ? true : null"
      [attr.aria-selected]="wizard.selected === step"
      [attr.aria-current]="wizard.selected === step ? 'step' : null"
      [attr.data-qa]="'mui-wizard-step-' + i">
      <div class="mui-wizard-stepper_step_indicator" aria-hidden="true">
        <span class="mui-wizard-stepper_step_circle"></span>
        <span class="mui-wizard-stepper_step_connection-line"></span>
      </div>
      <span class="mui-wizard-stepper_step_label">{{ step.label }}</span>
    </li>
  </ul>
  <div class="mui-wizard-stepper_current-step-label">
    {{ wizard?.selected?.label }}
  </div>
</div>
